//export const apiUrl = 'https://localhost:7181/'; // Local Api
export const apiUrl = 'https://be.doloni.in.ua/' // Delpoy API
export const defaultErrorMessage = 'Service is temporality disabled'
